import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Card, CardActionArea, CardContent, Typography } from '@material-ui/core';
import { Tooltip } from '@material-ui/core';
import FolderOutlinedIcon from '@material-ui/icons/FolderOutlined';

const useStyles = makeStyles((theme) => ({
  cardItem: {
    width: 160,
    borderRadius: theme.shape.borderRadius * 1.5,
    transition: 'transform 0.2s, box-shadow 0.2s, border-color 0.2s',
    border: `1px solid ${theme.palette.grey[300]}`,
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: theme.shadows[4],
    },
  },
  selected: {
    border: `2px solid ${theme.palette.primary.main}`,
    boxShadow: theme.shadows[6],
  },
  media1: {
    width: '100%',
    height: 140,
    objectFit: 'cover',
    borderTopLeftRadius: theme.shape.borderRadius * 1.5,
    borderTopRightRadius: theme.shape.borderRadius * 1.5,
  },
  media: {
    width: 160,
    height: 100, // height < width → rectangle
    objectFit: 'cover',
    display: 'block',
    margin: '0 auto',
  },
  
  content: {
    textAlign: 'center',
    padding: theme.spacing(1.5),
  },
}));

function formatDocName(doc) {
  return doc
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

const FolderGrid = ({ documents, onDocumentClick, selectedDoc }) => {
  const classes = useStyles();

  return (
    <>
      {documents.map((doc) => {
        const isSelected = selectedDoc === doc;

        return (
          <Grid item key={doc} xs="auto">
            <Tooltip title={doc} arrow>
            <Card
              className={`${classes.cardItem}`}
            >
              <CardActionArea onClick={() => onDocumentClick(doc)}>
                <FolderOutlinedIcon className={classes.media}/>
                <CardContent className={classes.content}>
                  <Typography variant="subtitle1" noWrap>
                    {formatDocName(doc)}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
            </Tooltip>
            
          </Grid>
        );
      })}
    </>
  );
};

export default FolderGrid;